import React from 'react';
import logo1 from './imgs/logo1.png';
import logo2 from './imgs/logo2.png';
import logo3 from './imgs/logo3.png';

const Features = () => (
  <section className="features py-5 text-center bg-features">
    <div className="container">
      <div className="row">
        {[{img: logo1, title: 'Easy Editor', text: 'Quickly add projects, skills, and more using our clean dashboard.'},
          {img: logo2, title: 'Beautiful and Simple', text: 'Match the tech vibe.'},
          {img: logo3, title: 'Public URL', text: 'Share your portfolio using your custom link.'}]
          .map((feat, i) => (
            <div className="col-md-4 mb-4" key={i}>
              <img src={feat.img} alt={feat.title} className="feature-icon mb-3" />
              <h3 className="fw-bold">{feat.title}</h3>
              <p>{feat.text}</p>
            </div>
          ))}
      </div>
    </div>
  </section>
);

export default Features;
